import { useState, useEffect } from 'react';
import axios from 'axios';
const T = { bg:'#f0f5e8', cream:'#fffef0', greenDk:'#1b5e20', maroon:'#6d1b1b', orange:'#e65100', border:'#c8e6c9', header:'linear-gradient(135deg,#090b72,#1a237e)' };
const STARS = ['அஸ்வினி','பரணி','கிருத்திகை','ரோகிணி','மிருகசீரிஷம்','திருவாதிரை','புனர்பூசம்','பூசம்','ஆயில்யம்','மகம்','பூரம்','உத்திரம்','அஸ்தம்','சித்திரை','சுவாதி','விசாகம்','அனுஷம்','கேட்டை','மூலம்','பூராடம்','உத்திராடம்','திருவோணம்','அவிட்டம்','சதயம்','பூரட்டாதி','உத்திரட்டாதி','ரேவதி'];

const MyMuhurthamsPage = () => {
  const [myStar, setMyStar] = useState(parseInt(localStorage.getItem('myStar')||'0'));
  const [data, setData] = useState([]);
  const [year, setYear] = useState(2026);

  useEffect(() => { localStorage.setItem('myStar', String(myStar)); }, [myStar]);

  useEffect(() => {
    axios.get('/data/muhurtham-results-2022-2029.json').then(r => {
      const filtered = r.data.filter(d => {
        if (!d.EnglishDate) return false;
        const p = d.EnglishDate.split('/');
        return parseInt(p[2]) === year;
      });
      setData(filtered);
    }).catch(() => {});
  }, [year]);

  return (
    <div style={{background:T.bg,minHeight:'80vh',padding:'10px'}}>
      <div style={{background:T.header,padding:'12px',borderRadius:'10px',textAlign:'center',marginBottom:'10px'}}>
        <img src="/images/rituals/kalyana-uthsavam.jpg" alt="கல்யாணம்" style={{height:'50px',borderRadius:'8px',marginBottom:'6px',border:'2px solid #f0d48a'}} />
        <h1 style={{color:'#fff',margin:0,fontSize:'1rem',fontWeight:900}}>💍 எனது முகூர்த்தம்</h1>
        <div style={{color:'#c8e6c9',fontSize:'0.7rem'}}>My Personalized Muhurtham Days</div>
      </div>
      <div style={{background:T.cream,padding:'10px',borderRadius:'8px',border:'1px solid '+T.border,marginBottom:'10px'}}>
        <label style={{fontSize:'0.75rem',fontWeight:700,color:T.greenDk}}>எனது நக்ஷத்ரம்</label>
        <select value={myStar} onChange={e=>setMyStar(parseInt(e.target.value))} style={{width:'100%',padding:'8px',borderRadius:'6px',border:'1px solid #ccc',fontWeight:700,marginBottom:'6px'}}>
          {STARS.map((s,i)=><option key={i} value={i}>{i+1}. {s}</option>)}
        </select>
        <label style={{fontSize:'0.75rem',fontWeight:700,color:T.greenDk}}>ஆண்டு</label>
        <select value={year} onChange={e=>setYear(parseInt(e.target.value))} style={{width:'100%',padding:'8px',borderRadius:'6px',border:'1px solid #ccc',fontWeight:700}}>
          {[2025,2026,2027,2028,2029].map(y=><option key={y} value={y}>{y}</option>)}
        </select>
      </div>
      <div style={{fontSize:'0.7rem',color:T.greenDk,fontWeight:700,marginBottom:'4px'}}>📊 {data.length} muhurtham days in {year}</div>
      {data.slice(0,50).map((d,i) => (
        <div key={i} style={{background:T.cream,padding:'6px 8px',borderRadius:'4px',marginBottom:'2px',border:'1px solid '+T.border,fontSize:'0.7rem'}}>
          <b style={{color:T.greenDk}}>{d.EnglishDate}</b> | {d.Day||d.DayNameInTamil||''} | {d.Nakshatra||d.NakshatraNameInTamil||''} | {d.Thithi||d.ThithiNameInTamil||''}
          {d.LagnaTime && <span style={{color:T.orange,fontWeight:600}}> ⏰ {d.LagnaTime}</span>}
        </div>
      ))}
    </div>
  );
};
export default MyMuhurthamsPage;